export type MaybeNull<T> = T | null;

/** A value that may have failed. `ok: true` carries the success value; `ok: false` carries the
 * error. */
export type Result<T, E> = { ok: true; value: T } | { ok: false; error: E };

/** Unwraps a `Result`, throwing if it's an error. Use only where failure means a genuine bug. */
export const unwrapOrThrow = <T>(result: Result<T, string>): T => {
  if (!result.ok) throw new Error(result.error);
  return result.value;
};
